import { Pessoa } from './pessoa';

export class Cedente {
    constructor(
        public cedenteId: number,
        public pessoaId: number,
        public dataInicio: Date,
        public dataFim: Date,
        public cedenteGuid: string,

        public pessoa: Pessoa
    ) { }
}

export class AssignorResponse {
    constructor(
        public cedenteId: number,
        public cedenteGuid: string,
        public nomeFantasia: string,
        public pinAtivo: boolean,
        public bloqueado: boolean
    ) { }
}
